import React from 'react';

import { MealPlanModule } from './MealPlanModule';

export const MealPlan = () => {
    return <MealPlanModule />;
};
